(ns splash.ui.lender-portal.components.nav-supporting-pages
  (:require
    ["react-router-dom" :refer [useParams useHistory]]
    [reagent-mui.icons.description-outlined :refer [description-outlined]]
    [reagent-mui.icons.summarize-outlined :refer [summarize-outlined]]
    [reagent.core :as r]
    [splash.ui.lender-portal.components.mui :as mui]
    [splash.ui.lender-portal.components.sidebar-card :refer [sidebar-card]]))

(defn navigation-button
  [text target icon]
  (let [history (useHistory)]
    [mui/button {:variant "text"
                 :onClick (fn [] (.push history target))
                 :startIcon (r/as-element [icon])}
     text]))

(defn supporting-pages
  []
  (r/with-let [params (useParams)
               application-id ^String (.-applicationId params)]
    [sidebar-card
     [:<>
      [mui/typography {:variant :cardTitle}
       "Supporting Pages"]
      [mui/stack
       [navigation-button
        "Application Summary"
        (str "/application/" application-id)
        summarize-outlined]
       [navigation-button
        "Documents"
        (str "/application/" application-id "/documents")
        description-outlined]]]]))
